const awsmobile = {
   "aws_project_region": "us-east-2",
   "aws_cognito_identity_pool_id": "us-east-2:a0d00695-b041-4823-9893-5c84056b8082",
   "aws_cognito_region": "us-east-2",
   "aws_user_pools_id": "us-east-2_0TqS8fVNJ",
   "aws_user_pools_web_client_id": "4tlaj614qjvk52oaiurobjq2jo"
}
export default awsmobile;
